module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Communication/Shield-user-316f4d2a83e1996aa9531cb222df3910.svg";